export default "__VITE_ASSET__e4l7iJFh__"